/** @format */

import { styled } from "@mui/material/styles";
import { colors, typographyHeaderColor } from "../../utility/types/constant";
import { Typography } from "@mui/material";

export const FooterContainer = styled("div")(({ theme }) => ({
	display: "grid",
	gridTemplateColumns: "repeat(6, 1fr)",
	gridGap: "20px",
	backgroundColor: colors.primary,
	padding: "40px 20px",
	minHeight: "auto",
	// Desktop: 6 columns
	[theme.breakpoints.down("lg")]: {
		gridTemplateColumns: "repeat(3, 1fr)",
		gridGap: "30px 20px",
	},
	// Tablet: 3 columns
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "repeat(2, 1fr)",
		gridGap: "30px 15px",
	},
	// Mobile: 1 column
	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "1fr",
		gridGap: "20px",
		padding: "30px 15px",
	},
}));

export const FooterChildContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	width: "100%",
	marginBottom: "20px",
	[theme.breakpoints.down("sm")]: {
		marginBottom: "10px",
	},
}));

export const SubHeaderDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	textAlign: "center",
	width: "100%",
	padding: "10px",
	gap: "12px",
	[theme.breakpoints.down("sm")]: {
		padding: "5px",
		gap: "10px",
	},
}));

export const ChildTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "18px",
	fontWeight: 700,
	color: typographyHeaderColor.primary,
	textAlign: "center",
	marginBottom: "10px",
	[theme.breakpoints.down("md")]: {
		fontSize: "16px",
	},
	[theme.breakpoints.down("sm")]: {
		fontSize: "15px",
		marginBottom: "8px",
	},
}));

export const TextAreaTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "14px",
	fontWeight: 400,
	color: typographyHeaderColor.white,
	textAlign: "center",
	wordBreak: "break-word",
	width: "100%",
	maxWidth: "200px",
	marginTop: "5px",
	marginBottom: "5px",
	[theme.breakpoints.down("sm")]: {
		fontSize: "13px",
	},
}));

export const CopyRightDiv = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	gridColumn: "1 / -1",
	padding: "30px 20px",
	marginTop: "20px",
	borderTop: "1px solid rgba(255, 255, 255, 0.1)",
	[theme.breakpoints.down("sm")]: {
		padding: "20px 15px",
		marginTop: "10px",
	},
}));

export const CopyRightTypography = styled(Typography)(({ theme }) => ({
	fontFamily: "'Montserrat', sans-serif",
	fontSize: "13px",
	fontWeight: 500,
	color: typographyHeaderColor.white,
	textAlign: "center",
	[theme.breakpoints.down("sm")]: {
		fontSize: "12px",
	},
}));
